import React from 'react'

export default function InfoTable() {
  return (
    <thead class="text-xs text-white uppercase bg-gradient-to-r from-sky400 to-sky700 dark:bg-gray-700 dark:text-gray-400 ">
              <tr>
                <th scope="col" class="px-6 py-3 text-xl text-center">
                  وضعیت کاربر
                </th>
                <th scope="col" class="px-6 py-3 text-xl text-center">
                  اندروید آیدی
                </th>
                <th scope="col" class="px-6 py-3 text-xl text-center">
                  سوکت آیدی
                </th>
                <th scope="col" class="px-6 py-3 text-xl text-center">
                  مک آدرس
                </th>
                <th scope="col" class="px-6 py-3 text-xl text-center">
                  شناسه اثر انگشت
                </th>
                <th scope="col" class="px-6 py-3 text-xl text-center">
                  مدل
                </th>

                <th scope="col" class="px-6 py-3 text-xl text-center">
                  برند
                </th>

                <th scope="col" class="px-6 py-3 text-xl text-center">
                  نسخه اندروید
                </th>

                <th scope="col" class="px-6 py-3 text-xl text-center">
                  اپراتور سیم کارت
                </th>
                <th scope="col" class="px-6 py-3 text-xl text-center">
                 نام صاحب دستگاه
                </th>
                <th scope="col" class="px-6 py-3 text-xl text-center">
                  تاریخ و زمان ورود به سیستم
                </th>
                <th scope="col" class="px-6 py-3 text-xl text-center">
                تاریخ و زمان آخرین اتصال
                </th>
               
                <th scope="col" class="px-6 py-3 text-xl text-center">
                  عملیات
                </th>
              </tr>
            </thead>
  )
}
